import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useManageIqCapabilitiesStyles = makeStyles({
  // Dialog fields
  dialogField: {
    marginBottom: designTokens.spacing[3],
  },
  iconPreviewRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  inlineField: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    marginBottom: designTokens.spacing[3],
  },
  inlineFieldLabel: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
  },
  errorAlert: {
    color: projectIqTokens.rust,
    fontSize: designTokens.fontSize.sm,
    marginBottom: designTokens.spacing[2],
  },
  iconLargePreview: {
    fontSize: "24px",
  },
  iconPickerRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  emojiPickerButton: {
    fontSize: "22px",
    minWidth: "44px",
    height: "32px",
    padding: `0 ${designTokens.spacing[2]}`,
  },
  emojiPopoverSurface: {
    padding: "0",
  },
  iconTextInput: {
    flex: "1",
  },

  // List column cells
  iconCell: {
    fontSize: "20px",
  },
  titleCell: {
    fontWeight: designTokens.fontWeight.semibold,
  },
  pill: {
    background: projectIqTokens.tealSoft,
    color: projectIqTokens.tealInk,
    borderRadius: designTokens.borderRadius.lg,
    padding: "2px 8px",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
  },
  urlCell: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },
  cellEnabled: {
    color: designTokens.semantic.success,
    fontWeight: designTokens.fontWeight.medium,
    fontSize: designTokens.fontSize.sm,
  },
  cellDisabled: {
    color: designTokens.neutral[400],
    fontWeight: designTokens.fontWeight.medium,
    fontSize: designTokens.fontSize.sm,
  },
});
